import React from 'react';
import { styled } from '@mui/material/styles';
import { AppBar, Toolbar, Typography, Button} from '@mui/material';
import { NavLink } from 'react-router-dom';
import { SIGN_IN_URL } from '../../auth/constant';
import { useAuth } from '../../auth/useAuth';

const PREFIX = 'Header';

const classes = {
    root: `${PREFIX}-root`,
    title: `${PREFIX}-title`,
    text: `${PREFIX}-text`,
    active: `${PREFIX}-active`,
    button: `${PREFIX}-button`,
    sectionDesktop: `${PREFIX}-sectionDesktop`,
    sectionMobile: `${PREFIX}-sectionMobile`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        flexGrow: 1,
    },

    [`& .${classes.title}`]: {
        flexGrow: 1,
        display: 'inline',
    },

    [`& .${classes.text}`]: {
        color: 'rgba(0,0,0,0.9)',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        },
    },

    [`& .${classes.active}`]: {
        backgroundColor: '#d8d8d8',
        borderRadius: '3px',
    },

    [`& .${classes.button}`]: {
        padding: theme.spacing(0, 2),
    },

    [`& .${classes.sectionDesktop}`]: {
        display: 'none',
        color: '#d8d8d8',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
    },

    [`& .${classes.sectionMobile}`]: {
        display: 'flex',
        color: '#d8d8d8',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    }
}));

const Header = () => {

    const {
        isAuthenticated, 
        user, 
        isLoading, 
        login,
        getAccessTokenSilently
    } = useAuth();

    return (
        <Root className={classes.root}>
            <AppBar color="default" position="fixed">
                <Toolbar>
                    {window.location.href.includes('lessons') && (
                        <>
                            <Typography variant="h6" className={classes.title}>
                                <NavLink to="/" className={classes.text}>
                                    ARCO Lessons Learned
                                </NavLink>
                            </Typography>
                        </>
                    )}
                    {!window.location.href.includes('lessons') && (
                        <>
                            <Typography variant="h6" className={classes.title}>
                                <NavLink to="/" className={classes.text}>
                                    ARCO Roster
                                </NavLink>
                            </Typography>
                        </>
                    )}
                    <div className={classes.sectionDesktop}>
                        {!isAuthenticated && (
                            <Button
                                className={classes.button}
                                onClick={() => login()}>
                                Sign In
                            </Button>
                        )}
                        {isAuthenticated && (
                            <NavLink to="/project-view" className={classes.text}>
                                <Button className={classes.button}>
                                    Go To Roster
                                </Button>
                            </NavLink>
                        )}
                    </div>
                    <div className={classes.sectionMobile}>
                        {!isAuthenticated && (
                            <Button
                                className={classes.button}
                                onClick={() => login()}>
                                Sign In
                            </Button>
                        )}
                        {isAuthenticated && (
                            <NavLink to="/project-view" className={classes.text}>
                                <Button className={classes.button}>
                                    Go To Roster
                                </Button>
                            </NavLink>
                        )}
                    </div>
                </Toolbar>
            </AppBar>
        </Root>
    );
};

export default Header;
